export default "__VITE_ASSET__Md2V9I3o__"